<template>
  <Dialog
    v-model:visible="showDialog"
    :modal="true"
    :header="model ? $t('SubTaxMaster.Edittitle') : $t('SubTaxMaster.title')"
    :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
    :style="{ width: '40vw' }"
    @after-hide="IsClear"
  >
    <!-- <Loader :loading="loading" /> -->
    <div>
      <b-form @submit.prevent="IsSubmit">
        <b-row>
          <b-col sm="8">
            <div class="field">
              <TextInput
                v-model="subtaxform.Name"
                type="text"
                placeholder=" "
                :requiredIcon="true"
                clearable
                id="Tax Name"
                name="Tax Name"
                :label="$t('SubTaxMaster.name')"
                :rules="{ required: true }"
                case="Capital"
                :autofocus="true"
              />
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="8">
            <div class="field">
              <CustomDropdown
                :required-icon="true"
                :label="$t('5004.taxtype')"
                v-model="subtaxform.subTaxType"
                :rules="{ required: true }"
                name="Tax type"
                id="Tax type"
                :items="taxresponse"
                @update:modelValue="handleDropdownChange"
              />
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col sm="8">
            <div class="field">
              <TextInput
                v-model="taxvalue.Percentage"
                type="text"
                placeholder=" "
                :requiredIcon="true"
                clearable
                id="Percentage"
                name="Percentage"
                :label="$t('SubTaxMaster.percentage')"
                :rules="{ required: showtxt1, decimal: true }"
                v-if="showtxt1"
              />
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col sm="8">
            <div class="field">
              <TextInput
                v-model="taxvalue.Amount"
                type="text"
                placeholder=" "
                :requiredIcon="true"
                clearable
                id="Amount"
                name="Amount"
                :label="$t('SubTaxMaster.amt')"
                :rules="{ required: showtxt2, decimal: true }"
                v-if="showtxt2"
              />
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <Footer
              @cancel="(showDialog = false), IsClear()"
              :cancelhide="false"
              :label="label"
              :loading="Saveloading"
            />
          </b-col>
        </b-row>
      </b-form>
    </div>
  </Dialog>
  <createdsuccessfully :visible="successpop" @ok="closetrigger()" />
  <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />
  <AlreadyExist :visible="alreadyexistpop" @ok="alreadyclosetrigger()" />
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";

import Footer from "../../../../../../components/FormComponents/Footer.vue";
import SubTaxService from "../../../../Service/SubTaxService";
import TextInput from "../../../../../../components/FormComponents/TextInput.vue";
import createdsuccessfully from "../../../../../../components/FormComponents/createdsuccessfully.vue";
import EditConfirmation from "../../../../../../components/FormComponents/EditConfirmation.vue";
import { useForm } from "vee-validate";
import { useI18n } from "vue-i18n";
import UpdatedSuccessfully from "../../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import AlreadyExist from "../../../../../../components/FormComponents/AlreadyExist.vue";
import CustomDropdown from "../../../../../../components/FormComponents/Dropdown.vue";
import Loader from "../../../../../../components/FormComponents/Loader.vue";
import moment from "moment";

export default defineComponent({
  props: {
    trigger: {
      readonly: false,
      type: Boolean,
      default: ref(false),
    },
    selectedItem: {
      type: Object,
      Default: () => {},
    },
    showButton: {
      type: Boolean,
      Required: true,
    },
    OperationID: {
      type: Object,
      default: {},
    },
    EntityId: {
      type: Number,
      default: 0,
    },
  },
  components: {
    Loader,

    Footer,
    TextInput,
    createdsuccessfully,
    EditConfirmation,
    UpdatedSuccessfully,
    CustomDropdown,
    AlreadyExist,
  },
  setup(props, { emit }) {
    let loading = ref(false);
    let Saveloading = ref(false);
    const { t } = useI18n();
    const label = ref(t("btn.save"));

    const showDialog = ref(false);
    const model: any = ref(props.selectedItem);
    const successpop = ref(false);
    const Editmodel = ref(false);
    const updatepop = ref(false);
    const { handleSubmit, errors, resetForm, resetField, validate } = useForm();
    const alreadyexistpop = ref(false);
    const showtxt1 = ref(false);
    const showtxt2 = ref(false);

    let session: any = localStorage.getItem("UsersData");

    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);
    let UserId = Number(session.UserId);
    // let Entitydata = ref();
    // Entitydata.value = localStorage.getItem("EntityData");
    // Entitydata.value = JSON.parse(Entitydata.value);
    let Entitydata = ref({
      EntityId: 0,
    });
    Entitydata.value.EntityId = props.EntityId;

    let taxresponse = [
      {
        value: 1,
        name: "Percentage",
      },
      {
        value: 2,
        name: "Amount",
      },
    ];

    async function handleDropdownChange() {
      debugger;
      if (subtaxform.value.subTaxType == 1) {
        showtxt1.value = true;
        showtxt2.value = false;
      } else if (subtaxform.value.subTaxType == 2) {
        showtxt2.value = true;
        showtxt1.value = false;
      }
    }

    if (model.value != null) {
      IsEdit();
    } else {
      IsCreate();
    }
    let taxvalue = ref({
      Percentage: "",
      subTaxType: 0,
      Amount: "",
    });
    const subtaxform = ref({
      CreatedAt: "",
      ModifiedAt: "",
      CreatedBy: 0,
      ModifiedBy: 0,
      Id: 0,
      Name: "",
      Percentage: 0.0,
      subTaxType: ref(),
      HospitalId: HospitalId,
      BranchId: BranchId,
      Amount: 0.0,
      EntityId: 0,
      EntityOperationId: 0,
    });
    const copydataModel = JSON.parse(JSON.stringify(subtaxform.value));
    //Edit-Popup
    async function IsConfirmEdit() {
      Editmodel.value = true;
    }

    //Get Value from Table and show in Popup
    async function IsEdit() {
      showDialog.value = true;

      // loading.value = true
      emit("loadershow");

      try {
        label.value = t("btn.update");
        let Id = model.value.Id;
        let response = await SubTaxService.getdata(Id);
        let datas = response["result"];
        Object.keys(subtaxform.value).forEach((key) => {
          if (datas[key]) subtaxform.value[key] = datas[key];
        });
        debugger;
        // loading.value = false
        emit("loaderhide");

        Editmodel.value = false;
        subtaxform.value.subTaxType = datas.SubTaxType;

        // alert(datas)
        if (datas.SubTaxType == 1) {
          showtxt1.value = true;
          showtxt2.value = false;
          taxvalue.value.Percentage = datas.Percentage;
          taxvalue.value.Amount = "0";
        } else if (datas.SubTaxType == 2) {
          showtxt2.value = true;
          showtxt1.value = false;
          taxvalue.value.Amount = datas.Amount;

          // taxvalue.value.Percentage='0'
        }
        emit("show");
      } catch (error) {
        // loading.value = false
        emit("loaderhide");

        console.log(error);
      }
    }
    onMounted(() => {
      debugger;
      document.addEventListener("keydown", onKeyUp);
    });
    let isSubmitCalled = false;
    function onKeyUp(event: KeyboardEvent) {
      debugger;

      if (event.altKey && event.key == "s") {
        if (!isSubmitCalled) {
          isSubmitCalled = true;
          IsSubmit();
        }
      } else if (
        (event.altKey && event.key == "c") ||
        (event.key == "Escape" &&
          successpop.value == false &&
          updatepop.value == false &&
          alreadyexistpop.value == false)
      ) {
        IsClear();
      } else if (
        event.key == "Escape" &&
        (successpop.value == true || updatepop.value == true)
      ) {
        closetrigger();
      } else if (event.key == "Escape" && alreadyexistpop.value == true) {
        alreadyclosetrigger();
      }
    }
    //Save-Fn
    const IsSubmit = async () => {
      // loading.value = true
      emit("loadershow");
      Saveloading.value = true;

      // Run validation on all fields
      const results = await validate();

      if (!results.valid) {
        const form = document.querySelector("form");
        const allFormFields: any = form?.querySelectorAll("[id]");
        console.log("All form fields:", allFormFields);

        const errorFields = Object.keys(results.errors);
        const firstErrorField = errorFields[0];
        console.log("First error:", firstErrorField);

        for (const field of allFormFields) {
          console.log("Checking field:", field.id);
          if (field.id === firstErrorField) {
            const component = field.closest(".field");

            if (!component) continue;

            if (component.querySelector(".p-calendar")) {
              const calendar = component.querySelector(".p-calendar input");
              if (calendar) {
                calendar.focus();
                calendar.click();
              }
            } else if (component.querySelector(".p-dropdown")) {
              const dropdown = component.querySelector(".p-dropdown");
              if (dropdown) {
                dropdown.click();
                dropdown.querySelector(".p-dropdown-trigger")?.click();
              }
            } else if (component.querySelector(".p-multiselect")) {
              const multiselect = component.querySelector(".p-multiselect");
              if (multiselect) {
                multiselect.click();
                multiselect.querySelector(".p-multiselect-trigger")?.click();
              }
            } else if (component.querySelector(".p-autocomplete")) {
              const autocomplete = component.querySelector(
                ".p-autocomplete input"
              );
              if (autocomplete) {
                autocomplete.focus();
                autocomplete.click();
              }
            } else {
              const input = component.querySelector("input, textarea");
              if (input) {
                input.focus();
                if (
                  input.type === "text" ||
                  input.type === "email" ||
                  input.tagName.toLowerCase() === "textarea"
                ) {
                  input.select();
                }
              }
            }

            component.scrollIntoView({ behavior: "smooth", block: "center" });
            break;
          }
        }

        Saveloading.value = false;
        return;
      }

      try {
        //Save Function for Edit(Update) Method
        let result: any;
        let msg = "";
        debugger;
        subtaxform.value.CreatedAt = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );
        subtaxform.value.ModifiedAt = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );
        subtaxform.value.BranchId = 0;
        subtaxform.value.HospitalId = HospitalId;
        subtaxform.value.ModifiedBy = UserId;
        subtaxform.value.CreatedBy = UserId;
        subtaxform.value.Percentage = Number(taxvalue.value.Percentage);
        subtaxform.value.Amount = Number(taxvalue.value.Amount);
        subtaxform.value.EntityId = Number(Entitydata.value.EntityId);

        if (subtaxform.value.subTaxType == 1) {
          subtaxform.value.Amount = 0.0;
        } else if (subtaxform.value.subTaxType == 2) {
          subtaxform.value.Percentage = 0.0;
        }

        if (subtaxform.value.Id != 0) {
          subtaxform.value.EntityOperationId = props.OperationID.UpdateId;
          const result = await SubTaxService.updatedata(subtaxform.value);
          msg = result["ErrorInfo"].ErrorCode;
          if (result["result"] == "Already" && msg == null) {
            Saveloading.value = false;
            emit("loaderhide");

            alreadyexistpop.value = true;
          } else if (msg == null) {
            Saveloading.value = false;
            emit("loaderhide");

            updatepop.value = true;
          }
        } else {
          //Save Function for Create Method

          subtaxform.value.EntityOperationId = props.OperationID.CreateId;
          const result = await SubTaxService.createdata(subtaxform.value);
          debugger;
          msg = result["ErrorInfo"].ErrorCode;
          if (result["result"] == "Already" && msg == null) {
            Saveloading.value = false;
            emit("loaderhide");

            alreadyexistpop.value = true;
          } else if (msg == null) {
            Saveloading.value = false;
            emit("loaderhide");

            successpop.value = true;
          }
          emit("show");
        }
      } catch (error) {
        emit("loaderhide");

        Saveloading.value = false;

        console.log(error);
      }
      debugger;
    };

    //Create-Popup
    function IsCreate() {
      showDialog.value = true;
    }

    //Popup-Close
    function closetrigger() {
      successpop.value = false;
      updatepop.value = false;
      emit("load");
      IsClear();
    }
    function alreadyclosetrigger() {
      debugger;
      alreadyexistpop.value = false;
      subtaxform.value.Name = "";
      //showDialog.value = true
    }

    //Clear Fn
    const IsClear = () => {
      Object.assign(subtaxform.value, copydataModel);
      showDialog.value = false;
      emit("update:selectedItem", undefined);
      emit("close");
    };

    return {
      Saveloading,
      loading,
      taxvalue,
      subtaxform,
      IsClear,
      IsEdit,
      IsCreate,
      showDialog,
      IsSubmit,
      IsConfirmEdit,
      successpop,
      Editmodel,
      closetrigger,
      updatepop,
      alreadyexistpop,
      alreadyclosetrigger,
      taxresponse,
      handleDropdownChange,
      showtxt1,
      showtxt2,
      label,
      model,
    };
  },
});
</script>
